<div *ngIf="!error && (!enrichedResponses || enrichedResponses.length <= 0) && sdcLog.message"
     class="alert alert-danger m-x-sm">
  <b>ERR</b><br>
  {{ sdcLog.message }}
</div>
<gp-sdc-person-feedback-error-component
  *ngIf="error"
  [error]="error">
</gp-sdc-person-feedback-error-component>
<gp-sdc-person-feedback-enriched-response
  *ngFor="let enrichedResponse of (enrichedResponses || [])"
  [enrichedResponse]="enrichedResponse">
</gp-sdc-person-feedback-enriched-response>
